module.exports = __webpack_public_path__ + "img/tynan_logo.88c2ed6a.webp";